import React from "react";
import { Select, Spin, Button } from "antd";
import { getWarehouseGoods } from "../service";
import debounce from "lodash/debounce";

const { Option } = Select;

export class SearchGoods extends React.Component {
  constructor(props) {
    super(props);
    this.fetchRequest = debounce(this.fetchRequest, 500);
  }

  state = {
    data: [],
    value: [],
    fetching: false,
  };

  fetchRequest = async (value) => {
    this.setState({ data: [], fetching: true });
    const res = await getWarehouseGoods({ goodsName: value, pageSize: 100, hasCode: 0 });
    this.setState({ data: res.data.data, fetching: false });
  };

  handleChange = (value, list) => {
    console.log("value", value);
    console.log("list", list);
    const newList = value.map((item, index) => ({...item, ...(list[index]).item}))
    // console.log("e", e);
    const newValue = [...newList];
    console.log('newValue',newValue)
    this.setState({
      value: newValue,
      // data: [],
      fetching: false,
    });
  };

  handleAdd = () => {
    const newValue = this.state.value.map(item => ({...item}))
    this.props.onAdd(newValue);
  };

  render() {
    const { fetching, data, value } = this.state;
    return (
      <>
        <Select
          mode="multiple"
          labelInValue
          placeholder="仅支持搜索库房内无条码商品"
          notFoundContent={fetching ? <Spin size="small" /> : null}
          onSearch={this.fetchRequest}
          onChange={this.handleChange}
          filterOption={(input, option) =>
            (option.props.children || "")
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
          }
          style={{ width: 350 }}
          value={value}
        >
          {data.map((d) => (
            <Option key={d.id} value={d.id} item={d}>
              {d.goodsName}
            </Option>
          ))}
        </Select>
        <Button
          type="primary"
          size="small"
          style={{ marginLeft: 8 }}
          onClick={this.handleAdd}
        >
          加入
        </Button>
      </>
    );
  }
}

export default SearchGoods;
